import { getDocument, GlobalWorkerOptions } from "pdfjs-dist/legacy/build/pdf"; // legacy-Build für Browser
import b64toBlob from "./b64toBlob";

// Worker manuell aus public oder via import
GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js?worker'; // Worker in public kopieren

async function pdf2b64(data) {
	const loadingTask = getDocument(data);

	return new Promise((resolve, reject) => {
		loadingTask.promise.then(pdf => {
			pdf.getPage(1).then(page => {
				const viewport = page.getViewport({ scale: 1.5 });
				const canvas = document.createElement("canvas");
				const context = canvas.getContext("2d");
				if (!context) return reject(new Error("Konnte Canvas-Kontext nicht erstellen"));

				canvas.width = viewport.width;
				canvas.height = viewport.height;

				page.render({ canvasContext: context, viewport }).promise
					.then(() => resolve(canvas.toDataURL("image/jpeg")))
					.catch(reject);
			}).catch(reject);
		}).catch(reject);
	});
}

export async function convertPDF2JPG(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);

		reader.onload = () => {
			pdf2b64(reader.result)
				.then(b64 => b64toBlob(b64).then(resolve).catch(reject))
				.catch(reject);
		};
		reader.onerror = reject;
	});
}
